document.addEventListener('DOMContentLoaded', () => {
  const menus = document.querySelectorAll('[data-faq-category-menu]')

  menus.forEach((menu) => {
    const button = menu.querySelector('[data-faq-category-menu-button]')
    const close = menu.querySelector('[data-faq-category-menu-close]')
    const options = menu.querySelector('[data-faq-category-menu-options]')
    const optionLinks = menu.querySelectorAll('[data-faq-category-menu-option]')

    if (!button || !options) return

    const closeMenu = () => {
      button.setAttribute('aria-expanded', 'false')
      options.hidden = true
      if (close) close.hidden = true
    }

    const openMenu = () => {
      button.setAttribute('aria-expanded', 'true')
      options.hidden = false
      if (close) close.hidden = false
    }

    button.addEventListener('click', () => {
      if (options.hidden) {
        openMenu()
        return
      }

      closeMenu()
    })

    optionLinks.forEach((optionLink) => {
      optionLink.addEventListener('click', () => {
        closeMenu()
      })
    })

    document.addEventListener('click', (event) => {
      if (menu.contains(event.target)) return
      closeMenu()
    })

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMenu()
    })
  })
})
